window.theme = window.theme || {};
theme.headerSection = (function () {
  function header() {
    const openButton = document.querySelector('.header__actions_btn--menu');
    const closeButton = document.querySelector('.offcanvas__close_btn');
    const drawer = document.querySelector('.offcanvas-header');
    const body = document.body;
    if (!openButton || !drawer) return;

    drawer.querySelectorAll('.offcanvas__sub_menu').forEach((submenu) => {
      const parent = submenu.parentElement;
      if (!parent || parent.querySelector(':scope > .offcanvas__sub_menu_toggle')) return;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'offcanvas__sub_menu_toggle';
      toggle.setAttribute('aria-label', 'Untermenü öffnen');
      parent.appendChild(toggle);
    });

    const close = () => {
      drawer.classList.remove('open');
      body.classList.remove('rezfon-menu-open');
      body.style.overflowY = '';
      openButton.setAttribute('aria-expanded', 'false');
    };

    openButton.addEventListener('click', (event) => {
      event.preventDefault();
      drawer.classList.add('open');
      body.classList.add('rezfon-menu-open');
      openButton.setAttribute('aria-expanded', 'true');
    });
    closeButton?.addEventListener('click', (event) => { event.preventDefault(); close(); });

    drawer.querySelectorAll('.offcanvas__sub_menu_toggle').forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const parent = toggle.parentElement;
        const submenu = toggle.previousElementSibling;
        const active = !parent.classList.contains('active');
        parent.classList.toggle('active', active);
        toggle.classList.toggle('active', active);
        toggle.setAttribute('aria-expanded', String(active));
        if (submenu) submenu.style.display = active ? 'block' : 'none';
      });
    });

    window.addEventListener('resize', () => { if (window.innerWidth >= 992) close(); }, { passive: true });
  }
  return header;
})();
